var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVanuatu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 20.0001C39.9999 19.1159 39.9419 18.2453 39.8306 17.3914H17.3911C13.3051 13.3056 5.8575 5.85854 5.85781 5.85791C-1.95264 13.6684 -1.95264 26.3316 5.85781 34.1422L17.3913 22.6088H39.8306C39.9418 21.7548 39.9999 20.8842 39.9999 20.0001V20.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9941 20.455C39.9933 20.4936 39.9924 20.5323 39.9913 20.5709C39.9923 20.5321 39.9932 20.4936 39.9941 20.455Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.975 21.0015C39.9733 21.0397 39.9706 21.0777 39.9686 21.1158C39.9706 21.0778 39.9731 21.0397 39.975 21.0015Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.948 21.4374C39.944 21.4935 39.9401 21.5497 39.9356 21.6057C39.9401 21.5497 39.944 21.4935 39.948 21.4374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8812 17.8202C39.8885 17.8871 39.8959 17.9539 39.9025 18.0209C39.8959 17.9538 39.8884 17.8871 39.8812 17.8202Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9683 18.8843C39.9704 18.9224 39.973 18.9605 39.9748 18.9987C39.9729 18.9605 39.9704 18.9223 39.9683 18.8843Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9913 19.4293C39.9924 19.4679 39.9932 19.5067 39.9941 19.5453C39.9933 19.5065 39.9924 19.4679 39.9913 19.4293Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9356 18.3942C39.9401 18.4502 39.944 18.5064 39.948 18.5625C39.944 18.5064 39.9401 18.4502 39.9356 18.3942Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8305 17.3912C39.8394 17.4597 39.8474 17.5286 39.8556 17.5973C38.6686 7.68467 30.2322 0 19.9998 0C14.4768 0 9.47677 2.23867 5.85748 5.85811L17.3906 17.3913H39.8305V17.3912Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8305 22.6087H17.3906L5.85748 34.1419C9.47677 37.7612 14.4768 40 19.9998 40C30.2322 40 38.6687 32.3153 39.8556 22.4026C39.8474 22.4713 39.8393 22.5402 39.8305 22.6087V22.6087Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9024 21.979C39.8958 22.046 39.8884 22.1128 39.8811 22.1797C39.8884 22.1128 39.8959 22.0461 39.9024 21.979Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9478 18.5625C39.9554 18.6695 39.9623 18.7766 39.9682 18.8841C39.9622 18.7766 39.9554 18.6695 39.9478 18.5625V18.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8557 17.5973C39.8647 17.6714 39.8732 17.7457 39.8812 17.8201C39.8731 17.7457 39.8646 17.6715 39.8557 17.5973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9023 18.0209C39.9145 18.145 39.9255 18.2695 39.9354 18.3944C39.9256 18.2695 39.9146 18.1449 39.9023 18.0209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 19.9999C39.9999 20.152 39.9975 20.3035 39.9942 20.4546C39.9975 20.3034 39.9999 20.1519 39.9999 19.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9684 21.1157C39.9625 21.2231 39.9556 21.3303 39.9481 21.4373C39.9556 21.3303 39.9624 21.2231 39.9684 21.1157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9354 21.6057C39.9255 21.7305 39.9145 21.855 39.9023 21.9791C39.9146 21.855 39.9256 21.7305 39.9354 21.6057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8812 22.1797C39.8732 22.2541 39.8647 22.3283 39.8557 22.4025C39.8646 22.3284 39.8731 22.2541 39.8812 22.1797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9942 19.545C39.9975 19.6963 39.9999 19.8479 39.9999 19.9998C39.9999 19.8479 39.9975 19.6963 39.9942 19.545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9748 18.9985C39.9818 19.1417 39.9871 19.2853 39.9912 19.4292C39.9871 19.2853 39.9819 19.1417 39.9748 18.9985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9912 20.5708C39.9871 20.7147 39.9818 20.8584 39.9748 21.0015C39.982 20.8583 39.9872 20.7147 39.9912 20.5708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9808 19.1231H16.6562L4.67525 7.14392C4.28798 7.55236 3.86822 8.12267 3.60861 8.52884L15.0663 19.9926L3.599 31.4601C3.82603 31.864 4.32064 32.4618 4.6679 32.8508L16.6565 20.8623H39.9836C39.996 20.5738 39.9999 20.2841 39.9999 19.9927C39.9999 19.6023 39.9891 19.3144 39.9808 19.1231Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85826 24.2633V22.588C6.52998 22.588 7.88989 21.228 7.88989 19.5564C7.88989 18.3737 6.92763 17.4115 5.74498 17.4115C4.93928 17.4115 4.28373 18.067 4.28373 18.8728C4.28373 19.388 4.70287 19.8073 5.21818 19.8073C5.50943 19.8073 5.74638 19.5702 5.74638 19.2789H7.42154C7.42154 20.494 6.4331 21.4824 5.21826 21.4824C3.77928 21.4825 2.60873 20.3117 2.60873 18.873C2.60873 17.1435 4.01576 15.7366 5.74506 15.7366C7.85146 15.7366 9.5652 17.4503 9.5652 19.5566C9.56512 22.1517 7.45364 24.2633 4.85826 24.2633V24.2633Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanuatu);
export default __webpack_public_path__ + "static/media/vanuatu.fe9d7bc76b08bf9303e5dd4578141698.svg";
export { ForwardRef as ReactComponent };